export default "__VITE_ASSET__48c74fae__"